
export default (date) => {
  return new Date(Date.parse(date.replace(/-/g, '/'))).toLocaleString('es').slice(0, -3)
}
